import type { PdsOrder, PdsOrderItem } from './types';

export interface ItemEdit {
  quantity: number;
  removed: boolean;
}

export interface OrderChange {
  item: PdsOrderItem;
  from: number;
  to: number;
  refundCents: number;
}

// Repli quand une ligne n'a pas de prix : le total payé réparti au prorata des pièces.
export const estimatedUnitCents = (order: PdsOrder) => {
  const pieces = order.items.reduce((sum, item) => sum + item.quantity, 0);
  return pieces ? Math.round(order.totalPaidCents / pieces) : 0;
};

// Montant d'affichage : le prix unitaire de la ligne quand le serveur le donne. Le serveur recalcule et rembourse le montant exact.
export const buildChanges = (
  order: PdsOrder,
  edits: Record<string, ItemEdit>,
): OrderChange[] => {
  const fallbackUnit = estimatedUnitCents(order);
  return order.items.flatMap((item) => {
    const edit = edits[item.id];
    // Le serveur refuse une quantité au-dessus de l'originale : on borne entre 0 et ce qui a été commandé.
    const to = !edit
      ? item.quantity
      : edit.removed
        ? 0
        : Math.min(Math.max(edit.quantity, 0), item.quantity);
    return to === item.quantity
      ? []
      : [
          {
            item,
            from: item.quantity,
            to,
            refundCents:
              (item.quantity - to) * (item.unitPriceCents ?? fallbackUnit),
          },
        ];
  });
};

export const totalRefundCents = (changes: OrderChange[]) =>
  changes.reduce((sum, change) => sum + change.refundCents, 0);
